import {
  MeterReadingsConfirmation,
  MeterReadings,
  MeterReadingsHistory,
  SubmitMeterReading,
} from '@ovotech/energy-cx';
import React, { ReactNode } from 'react';
import { Redirect, Route } from 'react-router-dom-v5';
import {
  SwitchWithNotFound,
  PageWithNavigationAndSectionPadding,
  KapiFeature,
} from '@/src/components';
import { ActionCard } from '@/src/components/ActionCard/ActionCard';
import {
  ROUTE_METER_READINGS,
  ROUTE_METER_READINGS_HISTORY,
  ROUTE_METER_READINGS_NEW,
} from '@/src/constants/routes';

const PageWithKapiFeature = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <PageWithNavigationAndSectionPadding title={title}>
    <KapiFeature>{children}</KapiFeature>
  </PageWithNavigationAndSectionPadding>
);

const MeterReadingsViewWithLayout = () => (
  <PageWithKapiFeature title="Meter readings">
    <MeterReadings />
  </PageWithKapiFeature>
);

const MeterReadingsConfirmViewWithLayout = () => (
  <PageWithKapiFeature title="Meter readings - Confirmation">
    <MeterReadingsConfirmation />
    <ActionCard
      cardsToShowByActionCode={['smart_booking_ovo_001']}
      utmSource="meter-readings"
    />
  </PageWithKapiFeature>
);

const MeterReadingsHistoryGasViewWithLayout = () => (
  <PageWithKapiFeature title="Meter readings history">
    <MeterReadingsHistory selectedFuel="gas" />
  </PageWithKapiFeature>
);

const MeterReadingsHistoryElecViewWithLayout = () => (
  <PageWithKapiFeature title="Meter readings history">
    <MeterReadingsHistory selectedFuel="electricity" />
  </PageWithKapiFeature>
);

const SubmitMeterRadingGasViewWithLayout = () => (
  <PageWithKapiFeature title="Meter Readings'">
    <SubmitMeterReading selectedFuel="gas" />
  </PageWithKapiFeature>
);

const SubmitMeterRadingElecViewWithLayout = () => (
  <PageWithKapiFeature title="Meter Readings'">
    <SubmitMeterReading selectedFuel="electricity" />
  </PageWithKapiFeature>
);

const MeterReadingsRoutes = () => (
  <SwitchWithNotFound>
    <Route
      exact
      path={ROUTE_METER_READINGS}
      component={MeterReadingsViewWithLayout}
    />
    <Route
      exact
      path={ROUTE_METER_READINGS_NEW}
      render={() => <Redirect to={ROUTE_METER_READINGS} />}
    />
    <Route
      exact
      path={`${ROUTE_METER_READINGS_NEW}/gas`}
      component={SubmitMeterRadingGasViewWithLayout}
    />
    <Route
      exact
      path={`${ROUTE_METER_READINGS_NEW}/electricity`}
      component={SubmitMeterRadingElecViewWithLayout}
    />
    <Route
      exact
      path={`${ROUTE_METER_READINGS_HISTORY}/gas`}
      component={MeterReadingsHistoryGasViewWithLayout}
    />
    <Route
      exact
      path={`${ROUTE_METER_READINGS_HISTORY}/electricity`}
      component={MeterReadingsHistoryElecViewWithLayout}
    />
    <Route
      exact
      path={`${ROUTE_METER_READINGS}/confirm`}
      component={MeterReadingsConfirmViewWithLayout}
    />
  </SwitchWithNotFound>
);

export default MeterReadingsRoutes;
